import App from "antd/es/app";

export const useModal = () => {
  const { modal } = App.useApp();

  return modal;
};
